export const readOnlyFieldStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
    minWidth: 100,
    '& fieldset': { borderColor: '#485D9A' },
    '&:hover fieldset': { borderColor: '#485D9A' },
    '&.Mui-focused fieldset': { borderColor: '#485D9A' }
  },
  '& .MuiInputLabel-root.Mui-focused': { color: '#485D9A' }
};

export const selectFieldStyle = {
  minWidth: 150,
  height: 38,
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
    '& fieldset': {
      borderColor: '#485D9A'
    },
    '&:hover fieldset': {
      borderColor: '#485D9A'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#485D9A'
    }
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#485D9A'
  }
};

export const datePickerStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    width: 100,
    '& fieldset': {
      borderColor: '#485D9A'
    },
    '&:hover fieldset': {
      borderColor: '#485D9A'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#485D9A'
    }
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#485D9A'
  }
};
